var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.componentKey },
    [
      _vm.articleContentLoading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [_c("loading-overlay")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" }, on: { enter: _vm.checkIEBrowser } },
        [
          _vm.checkArticleData
            ? _c("div", { staticClass: "container articles-container" }, [
                _c("div", { staticClass: "article-content-container pb-0" }, [
                  _vm.submitLoading
                    ? _c(
                        "div",
                        { staticClass: "container-submit-spinner" },
                        [_c("loading-overlay")],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-3" },
                      [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between px-3" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "article-content-background col-lg-9 col-12 mt-5 d-flex flex-column justify-content-between pt-4 px-0"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "article-inner-card" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "back-button-container pb-3"
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "px-0",
                                            on: {
                                              click: _vm.redirectToDefaultBrowse
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: ["fas", "arrow-left"]
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "pl-1" },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.platformTitle)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "title-header-text" },
                                      [
                                        _c(
                                          "span",
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.articleContent.name
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c("employee-hub-bookmark", {
                                              attrs: {
                                                title: _vm.articleContent.name
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "d-flex flex-lg-row flex-column mt-2 px-2 py-1 mb-2",
                                      class: _vm.platformDynamicBar
                                    }),
                                    _vm._v(" "),
                                    _vm.formattedUpdatedAt
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "pb-3 updated-at-text"
                                          },
                                          [
                                            _c("i", [
                                              _vm._v(
                                                "Last updated: " +
                                                  _vm._s(_vm.formattedUpdatedAt)
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.articleContent.faqs
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "knowledge-faq-article-content",
                                              {
                                                staticClass:
                                                  "content-container pt-3 pb-4",
                                                attrs: {
                                                  "article-header":
                                                    _vm.articleContent
                                                      .faqHeader,
                                                  "faqs-data":
                                                    _vm.articleContent.faqs,
                                                  "article-footer":
                                                    _vm.articleContent.faqFooter
                                                }
                                              }
                                            )
                                          ],
                                          1
                                        )
                                      : _c("div", [
                                          _c("div", {
                                            staticClass:
                                              "content-container pt-2",
                                            class: _vm.platformDynamicClass,
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.isCleanseHTML
                                                  ? _vm.$options.filters.consistentStylesKb(
                                                      _vm.articleContent.content
                                                    )
                                                  : _vm.articleContent.content
                                              )
                                            }
                                          })
                                        ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "justify-content-between" },
                                  [
                                    _vm.articleContent.displayAttachments &&
                                    _vm.articleContent.attachments &&
                                    _vm.articleContent.attachments.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "px-lg-5 px-2 pb-3 attachment-container"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "px-lg-4 px-3" },
                                              [
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "attachment-title"
                                                  },
                                                  [_vm._v("Attachments")]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.articleContent
                                                    .attachments,
                                                  function(attachment, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href:
                                                                attachment.url
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                attachment.fileName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rating-container d-flex align-items-lg-center justify-content-between px-3 py-3 flex-lg-row flex-column"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "pb-lg-0 pb-3" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.articleContent.kbNumber
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _vm.articleContent.rating > 0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mx-3 separator"
                                                  },
                                                  [_vm._v("|")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.articleContent.rating > 0
                                              ? _c(
                                                  "span",
                                                  _vm._l(_vm.rateArr, function(
                                                    star,
                                                    key
                                                  ) {
                                                    return _c(
                                                      "span",
                                                      {
                                                        key: key,
                                                        staticClass: "rate-star"
                                                      },
                                                      [
                                                        star <=
                                                        Math.ceil(
                                                          _vm.articleContent
                                                            .rating
                                                        )
                                                          ? _c(
                                                              "font-awesome-icon",
                                                              {
                                                                staticClass:
                                                                  "rating-solid-star",
                                                                attrs: {
                                                                  icon: [
                                                                    "fas",
                                                                    "star"
                                                                  ]
                                                                }
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        star >
                                                        Math.ceil(
                                                          _vm.articleContent
                                                            .rating
                                                        )
                                                          ? _c(
                                                              "font-awesome-icon",
                                                              {
                                                                attrs: {
                                                                  icon: [
                                                                    "far",
                                                                    "star"
                                                                  ]
                                                                }
                                                              }
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  }),
                                                  0
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-flex align-items-center"
                                            },
                                            [
                                              _c("font-awesome-icon", {
                                                attrs: { icon: ["far", "eye"] }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "pl-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.articleContent
                                                        .viewCount
                                                    ) + " Views"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.relatedArticles && _vm.relatedArticles.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "related-articles-container col-lg-3 col-12 mt-5 px-0 mx-0 pl-0"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "related-articles-title pt-4 pb-2 px-3"
                                      },
                                      [_c("h6", [_vm._v("Related articles")])]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.relatedArticles, function(
                                      relatedArticle
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: relatedArticle.id,
                                          staticClass: "related-article"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                title: relatedArticle.name,
                                                href: _vm.buildRelatedArticleUrl(
                                                  relatedArticle
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(relatedArticle.name)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _vm.showRelatedArticlesTitle
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "related-article pt-3"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "view-all-articles",
                                                on: {
                                                  click:
                                                    _vm.redirectToDefaultBrowse
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.platformTitle)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showSuccessfulMessage
                          ? _c("div", { staticClass: "row mt-4" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-9 feedback-message-container py-3"
                                },
                                [
                                  _c("h6", [
                                    _vm._v("Thank you for your feedback!")
                                  ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "row footer-article-content",
                            class:
                              _vm.articleComments &&
                              _vm.articleComments.length === 0
                                ? "py-5"
                                : "py-4"
                          },
                          [
                            _c("div", { staticClass: "col-lg-9" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "Have feedback on this info? Please send us a comment!"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-3" },
                                [
                                  _vm.isEditorReady
                                    ? _c("froala", {
                                        staticClass: "mb-4",
                                        attrs: { config: _vm.froalaConfig },
                                        model: {
                                          value: _vm.feedbackText,
                                          callback: function($$v) {
                                            _vm.feedbackText = $$v
                                          },
                                          expression: "feedbackText"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showFeedbackValidationError
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "text-danger" }, [
                                      _vm._v(
                                        "Please provide both a comment and a rating to proceed."
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row rate-container flex-lg-row justify-content-between",
                                  class:
                                    _vm.articleComments &&
                                    _vm.articleComments.length === 0
                                      ? "mb-5"
                                      : null
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-12 d-flex flex-column flex-lg-row mb-lg-0"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "h-100 align-items-center d-flex"
                                        },
                                        [
                                          _c("span", { staticClass: "pr-2" }, [
                                            _vm._v("Rate this article:")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "d-flex" },
                                            _vm._l(_vm.rateArr, function(
                                              rate,
                                              key
                                            ) {
                                              return _c(
                                                "button",
                                                {
                                                  key: key,
                                                  staticClass:
                                                    "rate-button px-0 pr-1",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setArticleRate(
                                                        rate
                                                      )
                                                    },
                                                    mouseover: function(
                                                      $event
                                                    ) {
                                                      return _vm.setRateHover(
                                                        rate
                                                      )
                                                    },
                                                    mouseleave: function(
                                                      $event
                                                    ) {
                                                      return _vm.resetRateHover()
                                                    }
                                                  }
                                                },
                                                [
                                                  rate > _vm.articleRate
                                                    ? _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: ["far", "star"]
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  rate <= _vm.articleRate
                                                    ? _c("font-awesome-icon", {
                                                        staticClass:
                                                          "rate-active-button",
                                                        attrs: {
                                                          icon: ["fas", "star"]
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "submit-rating-button ml-lg-2 py-2",
                                          attrs: {
                                            disabled: _vm.disableSubmitButton
                                          },
                                          on: { click: _vm.submitArticleRate }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tSUBMIT\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("knowledge-article-comments", {
                          attrs: { "article-comments": _vm.articleComments }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.checkNoArticle
        ? _c(
            "div",
            {
              staticClass:
                "py-5 row no-article-container justify-content-center"
            },
            [
              _vm.errorMessage
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "fade-in-out alert alert-error px-4" },
                        [_c("div", [_vm._v(_vm._s(_vm.errorMessage))])]
                      )
                    ])
                  ])
                : _c("h4", [
                    _vm._v("Sorry, the selected article was not found.")
                  ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19acf730", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19acf730","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeArticle.vue
// module id = null
// module chunks = 